export default "__VITE_ASSET__C$eYoBhp__"